import { DateFilterOperation } from "abweb/dto/generated/inputargs/DateFilterOperation";
import { DateFilterValueBase } from "abweb/dto/generated/inputargs/DateFilterValueBase";
import { DateUtils } from "abweb/utils/DateUtils";
export class DateFilterValue extends DateFilterValueBase {
  static createDateFilterValue(firstDate, isDateTime, isOpNegated, latest, op, secondDate) {
    const retVal = new DateFilterValue();
    retVal.initDateFilterValue(null, firstDate, isDateTime, isOpNegated, latest, op, secondDate);
    return retVal;
  }

  // This is called when coming FROM tsog, where Date values coming in are expected to be in UTC-midnight format.
  initDateFilterValue(uuid, firstDate, isDateTime, isOpNegated, latest, op, secondDate) {
    // If the server is sending a DATE, it is sending the Date values as midnight UTC so need to convert to
    // midnight local time so that the day is correct. See MH-2963.
    super.initDateFilterValue(null, isDateTime ? firstDate : DateUtils.convertDateFromUtcToLocal(firstDate), isDateTime, isOpNegated, latest, op, isDateTime ? secondDate : DateUtils.convertDateFromUtcToLocal(secondDate));
  }

  /**
   * This is an override of the generated toTSOG method that converts the local Date values to UTC-midnight values.
   * For DATE values, we truncate to midnight. For DATETIME values, we leave the values alone. See MH-2963.
   */
  toTSOG(result, serializeContext) {
    const retVal = super.toTSOG(result, serializeContext);
    if (!this.isDateTime) {
      if (this.firstDate != null) {
        retVal.firstDate = DateUtils.convertDateFromLocalToUtc(this.firstDate);
      }
      if (this.secondDate != null) {
        retVal.secondDate = DateUtils.convertDateFromLocalToUtc(this.secondDate);
      }
    }
    return retVal;
  }
  constructor() {
    super();
    this.initDateFilterValue(null, null, true, false, null, DateFilterOperation.After, null);
  }
  clone() {
    const retVal = new DateFilterValue();
    retVal.isDateTime = this.isDateTime;
    retVal.op = this.op;
    retVal.isOpNegated = this.isOpNegated;
    retVal.firstDate = this.firstDate;
    retVal.secondDate = this.secondDate;
    retVal.latest = this.latest ? this.latest.clone() : null;
    return retVal;
  }
}
//# sourceMappingURL=DateFilterValue.js.map
